var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlansPromoStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.22 4.073l-1.124.202a.1.1 0 00-.034.19l.986.575a3.156 3.156 0 011.516 2.167l.203 1.123a.1.1 0 00.145.078.1.1 0 00.044-.045l.575-.986a3.156 3.156 0 012.167-1.516l1.124-.202a.1.1 0 00.033-.19l-.986-.575a3.156 3.156 0 01-1.516-2.166l-.203-1.124a.1.1 0 00-.144-.078.1.1 0 00-.045.045l-.575.986a3.156 3.156 0 01-2.166 1.516zM2.837 15.91l-1.452.847a.151.151 0 00.05.279l1.654.299a4.65 4.65 0 013.191 2.232l.848 1.452a.151.151 0 00.278-.05l.298-1.653a4.649 4.649 0 012.233-3.191l1.451-.848a.151.151 0 00-.049-.279L9.685 14.7a4.651 4.651 0 01-3.191-2.232l-.848-1.452a.15.15 0 00-.278.05l-.299 1.654a4.649 4.649 0 01-2.232 3.19z",
    fill: "#fff"
  })));
}

export default SvgPlansPromoStars;